import styled from "styled-components";

export const CustomInputBoxStyle = styled('input')`
    background: transparent;
    border: ${({theme}) => theme.borders.headerBorder};
    margin: 0.5rem 0 0.5rem 1rem;
    min-height: 40px;
    box-shadow: inset 1px 1px 6.2px hsl(0deg 0% 0% / 0.3) !important;
    &::placeholder {
        color: #fff;
        opacity: 1; /* Ensures full opacity for white */
    }
`
export function CustomInputBox({onChange, onKeyDown, value}) {
    return(
        <CustomInputBoxStyle
          className="rounded w-full color-white px-2"
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onKeyDown()}
          value={value}
          placeholder="search"
        />
    )
}